/* eslint-disable */
/* !!! THIS FILE WAS GENERATED BY GRAPHQL-CODE-GENERATOR !!!
* !!! DO NOT MODIFY THIS FILE BY YOURSELF  !!! */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Chat_DateScalar: { input: any; output: any; }
  CommerceV2_DateTime: { input: any; output: any; }
  CommerceV2_Price: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Giveaways_DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Voting_DateTime: { input: any; output: any; }
};

export enum Chat_ChatBanEventType {
  ChatBanCreated = 'CHAT_BAN_CREATED',
  ChatBanDeleted = 'CHAT_BAN_DELETED'
}

export enum Chat_ChatEventType {
  ChatUpdated = 'CHAT_UPDATED'
}

export enum CommerceV2_CommerceProvider {
  Target = 'Target'
}

export type CommerceV2_CreatePreselectedVariantMappingInput = {
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};

export type CommerceV2_CreateSaleInput = {
  preselectedVariantMappings?: InputMaybe<Array<CommerceV2_CreatePreselectedVariantMappingInput>>;
  productIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** Represents an ISO 4217 Currency Code: https://en.wikipedia.org/wiki/ISO_4217 */
export enum CommerceV2_CurrencyCode {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gmd = 'GMD',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Isk = 'ISK',
  Jep = 'JEP',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Srd = 'SRD',
  Std = 'STD',
  Syp = 'SYP',
  Thb = 'THB',
  Tmt = 'TMT',
  Tnd = 'TND',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW'
}

export enum CommerceV2_SaleEventType {
  SaleCreated = 'SALE_CREATED',
  SaleDeleted = 'SALE_DELETED',
  SaleUpdated = 'SALE_UPDATED'
}

export type CommerceV2_UpdateSaleInput = {
  id: Scalars['ID']['input'];
  preselectedVariantMappings: Array<CommerceV2_CreatePreselectedVariantMappingInput>;
  productIds: Array<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type DisablePluginInput = {
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Force the plugin to stay disabled at the start of any future broadcast */
  persistent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String']['input'];
};

export type DisablePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins?: InputMaybe<Array<DisablePluginInput>>;
};

export type EnablePluginInput = {
  options?: InputMaybe<Scalars['JSON']['input']>;
  /** Force the plugin to stay enabled at the end of the broadcast */
  persistent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique key for the plugin to enable */
  pluginKey: Scalars['String']['input'];
};

export type EnablePluginsInput = {
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins: Array<EnablePluginInput>;
};

/** The input for creating an entry */
export type Giveaways_CreateEntryInput = {
  /** The display name of the entrant */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the entrant */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the entrant */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the entrant */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** The input for creating a giveaway */
export type Giveaways_CreateGiveawayInput = {
  /** The required fields for the giveaway */
  requiredFields: Array<Giveaways_GiveawayRequiredField>;
  /** The title of the giveaway */
  title: Scalars['String']['input'];
};

export enum Giveaways_EntryEventType {
  EntryCreated = 'ENTRY_CREATED',
  EntryDrawn = 'ENTRY_DRAWN',
  EntryUpdated = 'ENTRY_UPDATED'
}

export enum Giveaways_GiveawayEventType {
  GiveawayCreated = 'GIVEAWAY_CREATED',
  GiveawayStatusChanged = 'GIVEAWAY_STATUS_CHANGED',
  GiveawayUpdated = 'GIVEAWAY_UPDATED'
}

export enum Giveaways_GiveawayRequiredField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME'
}

export enum Giveaways_GiveawaySortField {
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS'
}

export enum Giveaways_GiveawayStatus {
  Closed = 'CLOSED',
  Ended = 'ENDED',
  Open = 'OPEN',
  Ready = 'READY'
}

export type Giveaways_GiveawaysFilterInput = {
  /** Whether to include archived giveaways */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** The broadcast ID of the giveaways to filter by */
  broadcastId?: InputMaybe<Scalars['ID']['input']>;
  /** The recording ID of the giveaways to filter by */
  recordingId?: InputMaybe<Scalars['ID']['input']>;
  /** The status of the giveaways to filter by */
  status?: InputMaybe<Giveaways_GiveawayStatus>;
};

export type Giveaways_GiveawaysSortInput = {
  /** The direction to sort the giveaways by */
  direction?: InputMaybe<Giveaways_SortDirection>;
  /** The field to sort the giveaways by */
  field?: InputMaybe<Giveaways_GiveawaySortField>;
};

export enum Giveaways_SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The input for updating a giveaway */
export type Giveaways_UpdateGiveawayInput = {
  /** The ID of the giveaway to update */
  id: Scalars['ID']['input'];
  /** The required fields for the giveaway */
  requiredFields?: InputMaybe<Array<Giveaways_GiveawayRequiredField>>;
  /** The title of the giveaway */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The state of the plugin */
export enum PluginState {
  Disabled = 'disabled',
  Enabled = 'enabled'
}

/** Represents the items to add to a cart */
export type Target_CreateCartInput = {
  /** The number of items to add */
  quantity: Scalars['Int']['input'];
  /** The TCIN of the item to add */
  tcin: Scalars['String']['input'];
};

export type UpdatePluginInput = {
  options: Scalars['JSON']['input'];
  /** The unique key for the plugin to update */
  pluginKey: Scalars['String']['input'];
};

export type UpdatePluginsInput = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  plugins: Array<UpdatePluginInput>;
};

export type Voting_AnswerBarStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius?: InputMaybe<Scalars['Float']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  padding: Scalars['Float']['input'];
  resultFill: Voting_FillInput;
  textFill: Voting_FillInput;
  voteDisplayFormat?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a new answer to be created */
export type Voting_CreateAnswerInput = {
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  votes?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a new question to be created */
export type Voting_CreateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_CreateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']['input']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_CreateStylesInput>;
  /** The text of the question */
  text: Scalars['String']['input'];
};

export type Voting_CreateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  name: Scalars['String']['input'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Voting_FillInput = {
  alpha?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['Int']['input']>;
};

export type Voting_PromptStylesInput = {
  backgroundFill: Voting_FillInput;
  cornerRadius: Scalars['Float']['input'];
  padding: Scalars['Float']['input'];
  textFill: Voting_FillInput;
};

/** Pagination options for Question feed */
export type Voting_QuestionFeedOptions = {
  cursor?: InputMaybe<Scalars['Voting_DateTime']['input']>;
  /** Max number of elements per fetch. (Default: 10, Fetch all: -1) */
  limit: Scalars['Int']['input'];
};

export type Voting_ResultStylesInput = {
  backgroundFill: Voting_FillInput;
  childGaps: Scalars['Float']['input'];
  cornerRadius: Scalars['Float']['input'];
  direction: Scalars['String']['input'];
  padding: Scalars['Float']['input'];
  topMargin: Scalars['Float']['input'];
};

/** Represents an update to a specific answer */
export type Voting_UpdateAnswerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  votes?: InputMaybe<Scalars['Int']['input']>;
};

export type Voting_UpdateQuestionInput = {
  /** The answers for this question */
  answers?: InputMaybe<Array<Voting_UpdateAnswerInput>>;
  /** The ID of the answer that is the correct one */
  correctAnswerId?: InputMaybe<Scalars['ID']['input']>;
  /** Does this question have a correct answer */
  hasCorrectAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** The number of votes each user may make for this question */
  maxVotesAllowed?: InputMaybe<Scalars['Int']['input']>;
  /** The styles to apply on this Question when displayed to viewers */
  styles?: InputMaybe<Voting_UpdateStylesInput>;
  /** The text of the question */
  text: Scalars['String']['input'];
};

export type Voting_UpdateStylesInput = {
  answerBarStyles: Array<Voting_AnswerBarStylesInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  promptStyles: Voting_PromptStylesInput;
  resultStyles: Voting_ResultStylesInput;
  version: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type Voting_VotesInput = {
  answerId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
};

export type EntryFieldsFragment = { __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string };

export type GiveawayFieldsFragment = { __typename?: 'Giveaways_Giveaway', id: string, title: string, status: Giveaways_GiveawayStatus, requiredFields: Array<Giveaways_GiveawayRequiredField>, drawnEntries: Array<{ __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string }> };

export type GiveawayQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GiveawayQuery = { __typename?: 'Query', giveaways_giveaway: { __typename?: 'Giveaways_Giveaway', id: string, title: string, status: Giveaways_GiveawayStatus, requiredFields: Array<Giveaways_GiveawayRequiredField>, drawnEntries: Array<{ __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string }> } | null };

export type OpenGiveawaysQueryVariables = Exact<{
  broadcastId: Scalars['ID']['input'];
}>;


export type OpenGiveawaysQuery = { __typename?: 'Query', giveaways_giveaways: { __typename?: 'Giveaways_GiveawayPage', nextCursor: string | null, hasMore: boolean, records: Array<{ __typename?: 'Giveaways_Giveaway', id: string, title: string, status: Giveaways_GiveawayStatus, requiredFields: Array<Giveaways_GiveawayRequiredField>, drawnEntries: Array<{ __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string }> }> } };

export type EntryByGiveawayIdQueryVariables = Exact<{
  giveawayId: Scalars['ID']['input'];
}>;


export type EntryByGiveawayIdQuery = { __typename?: 'Query', giveaways_entryByGiveawayId: { __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string } | null };

export type CreateEntryMutationVariables = Exact<{
  giveawayId: Scalars['ID']['input'];
  entry: Giveaways_CreateEntryInput;
}>;


export type CreateEntryMutation = { __typename?: 'Mutation', giveaways_createEntry: { __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string } };

export type GiveawayEventSubscriptionVariables = Exact<{
  giveawayId: InputMaybe<Scalars['ID']['input']>;
  broadcastId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GiveawayEventSubscription = { __typename?: 'Subscription', giveaways_giveawayEvent: { __typename?: 'Giveaways_GiveawayEvent', id: string, type: Giveaways_GiveawayEventType, giveaway: { __typename?: 'Giveaways_Giveaway', id: string, title: string, status: Giveaways_GiveawayStatus, requiredFields: Array<Giveaways_GiveawayRequiredField>, drawnEntries: Array<{ __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string }> } } };

export type EntryEventSubscriptionVariables = Exact<{
  broadcastId: InputMaybe<Scalars['ID']['input']>;
  giveawayId: InputMaybe<Scalars['ID']['input']>;
}>;


export type EntryEventSubscription = { __typename?: 'Subscription', giveaways_entryEvent: { __typename?: 'Giveaways_EntryEvent', id: string, type: Giveaways_EntryEventType, entry: { __typename?: 'Giveaways_Entry', id: string, drawnAt: string | null, firstName: string | null, isMe: boolean, giveawayId: string } } };

export const EntryFieldsFragmentDoc = gql`
    fragment EntryFields on Giveaways_Entry {
  id
  drawnAt
  firstName
  isMe
  giveawayId
}
    `;
export const GiveawayFieldsFragmentDoc = gql`
    fragment GiveawayFields on Giveaways_Giveaway {
  id
  title
  status
  requiredFields
  drawnEntries {
    ...EntryFields
  }
}
    ${EntryFieldsFragmentDoc}`;
export const GiveawayDocument = gql`
    query Giveaway($id: ID!) {
  giveaways_giveaway(id: $id) {
    ...GiveawayFields
  }
}
    ${GiveawayFieldsFragmentDoc}`;

/**
 * __useGiveawayQuery__
 *
 * To run a query within a React component, call `useGiveawayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiveawayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiveawayQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGiveawayQuery(baseOptions: Apollo.QueryHookOptions<GiveawayQuery, GiveawayQueryVariables> & ({ variables: GiveawayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiveawayQuery, GiveawayQueryVariables>(GiveawayDocument, options);
      }
export function useGiveawayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiveawayQuery, GiveawayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiveawayQuery, GiveawayQueryVariables>(GiveawayDocument, options);
        }
export function useGiveawaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GiveawayQuery, GiveawayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GiveawayQuery, GiveawayQueryVariables>(GiveawayDocument, options);
        }
export type GiveawayQueryHookResult = ReturnType<typeof useGiveawayQuery>;
export type GiveawayLazyQueryHookResult = ReturnType<typeof useGiveawayLazyQuery>;
export type GiveawaySuspenseQueryHookResult = ReturnType<typeof useGiveawaySuspenseQuery>;
export type GiveawayQueryResult = Apollo.QueryResult<GiveawayQuery, GiveawayQueryVariables>;
export const OpenGiveawaysDocument = gql`
    query OpenGiveaways($broadcastId: ID!) {
  giveaways_giveaways(
    filter: {broadcastId: $broadcastId, status: OPEN, archived: false}
  ) {
    records {
      ...GiveawayFields
    }
    nextCursor
    hasMore
  }
}
    ${GiveawayFieldsFragmentDoc}`;

/**
 * __useOpenGiveawaysQuery__
 *
 * To run a query within a React component, call `useOpenGiveawaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenGiveawaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenGiveawaysQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useOpenGiveawaysQuery(baseOptions: Apollo.QueryHookOptions<OpenGiveawaysQuery, OpenGiveawaysQueryVariables> & ({ variables: OpenGiveawaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>(OpenGiveawaysDocument, options);
      }
export function useOpenGiveawaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>(OpenGiveawaysDocument, options);
        }
export function useOpenGiveawaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>(OpenGiveawaysDocument, options);
        }
export type OpenGiveawaysQueryHookResult = ReturnType<typeof useOpenGiveawaysQuery>;
export type OpenGiveawaysLazyQueryHookResult = ReturnType<typeof useOpenGiveawaysLazyQuery>;
export type OpenGiveawaysSuspenseQueryHookResult = ReturnType<typeof useOpenGiveawaysSuspenseQuery>;
export type OpenGiveawaysQueryResult = Apollo.QueryResult<OpenGiveawaysQuery, OpenGiveawaysQueryVariables>;
export const EntryByGiveawayIdDocument = gql`
    query EntryByGiveawayId($giveawayId: ID!) {
  giveaways_entryByGiveawayId(giveawayId: $giveawayId) {
    ...EntryFields
  }
}
    ${EntryFieldsFragmentDoc}`;

/**
 * __useEntryByGiveawayIdQuery__
 *
 * To run a query within a React component, call `useEntryByGiveawayIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntryByGiveawayIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryByGiveawayIdQuery({
 *   variables: {
 *      giveawayId: // value for 'giveawayId'
 *   },
 * });
 */
export function useEntryByGiveawayIdQuery(baseOptions: Apollo.QueryHookOptions<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables> & ({ variables: EntryByGiveawayIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>(EntryByGiveawayIdDocument, options);
      }
export function useEntryByGiveawayIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>(EntryByGiveawayIdDocument, options);
        }
export function useEntryByGiveawayIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>(EntryByGiveawayIdDocument, options);
        }
export type EntryByGiveawayIdQueryHookResult = ReturnType<typeof useEntryByGiveawayIdQuery>;
export type EntryByGiveawayIdLazyQueryHookResult = ReturnType<typeof useEntryByGiveawayIdLazyQuery>;
export type EntryByGiveawayIdSuspenseQueryHookResult = ReturnType<typeof useEntryByGiveawayIdSuspenseQuery>;
export type EntryByGiveawayIdQueryResult = Apollo.QueryResult<EntryByGiveawayIdQuery, EntryByGiveawayIdQueryVariables>;
export const CreateEntryDocument = gql`
    mutation CreateEntry($giveawayId: ID!, $entry: Giveaways_CreateEntryInput!) {
  giveaways_createEntry(giveawayId: $giveawayId, entry: $entry) {
    ...EntryFields
  }
}
    ${EntryFieldsFragmentDoc}`;
export type CreateEntryMutationFn = Apollo.MutationFunction<CreateEntryMutation, CreateEntryMutationVariables>;

/**
 * __useCreateEntryMutation__
 *
 * To run a mutation, you first call `useCreateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntryMutation, { data, loading, error }] = useCreateEntryMutation({
 *   variables: {
 *      giveawayId: // value for 'giveawayId'
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useCreateEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntryMutation, CreateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntryMutation, CreateEntryMutationVariables>(CreateEntryDocument, options);
      }
export type CreateEntryMutationHookResult = ReturnType<typeof useCreateEntryMutation>;
export type CreateEntryMutationResult = Apollo.MutationResult<CreateEntryMutation>;
export type CreateEntryMutationOptions = Apollo.BaseMutationOptions<CreateEntryMutation, CreateEntryMutationVariables>;
export const GiveawayEventDocument = gql`
    subscription GiveawayEvent($giveawayId: ID, $broadcastId: ID) {
  giveaways_giveawayEvent(giveawayId: $giveawayId, broadcastId: $broadcastId) {
    id
    type
    giveaway {
      ...GiveawayFields
    }
  }
}
    ${GiveawayFieldsFragmentDoc}`;

/**
 * __useGiveawayEventSubscription__
 *
 * To run a query within a React component, call `useGiveawayEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGiveawayEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiveawayEventSubscription({
 *   variables: {
 *      giveawayId: // value for 'giveawayId'
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useGiveawayEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GiveawayEventSubscription, GiveawayEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GiveawayEventSubscription, GiveawayEventSubscriptionVariables>(GiveawayEventDocument, options);
      }
export type GiveawayEventSubscriptionHookResult = ReturnType<typeof useGiveawayEventSubscription>;
export type GiveawayEventSubscriptionResult = Apollo.SubscriptionResult<GiveawayEventSubscription>;
export const EntryEventDocument = gql`
    subscription EntryEvent($broadcastId: ID, $giveawayId: ID) {
  giveaways_entryEvent(broadcastId: $broadcastId, giveawayId: $giveawayId) {
    id
    type
    entry {
      ...EntryFields
    }
  }
}
    ${EntryFieldsFragmentDoc}`;

/**
 * __useEntryEventSubscription__
 *
 * To run a query within a React component, call `useEntryEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEntryEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryEventSubscription({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *      giveawayId: // value for 'giveawayId'
 *   },
 * });
 */
export function useEntryEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EntryEventSubscription, EntryEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EntryEventSubscription, EntryEventSubscriptionVariables>(EntryEventDocument, options);
      }
export type EntryEventSubscriptionHookResult = ReturnType<typeof useEntryEventSubscription>;
export type EntryEventSubscriptionResult = Apollo.SubscriptionResult<EntryEventSubscription>;